//https://www.codegrepper.com/code-examples/javascript/accept+2+values+after+decimal+in+angular+forms
//https://www.thetopsites.net/article/50722368.shtml
//https://www.pluralsight.com/guides/generating-a-custom-directive-with-the-cli

//https://upliftskills.us/blog/2018/11/08/how-to-add-directive-dynamically-in-angular-2-4-6/
import { Directive, ElementRef, Input, HostListener } from '@angular/core';
import { ConnectableObservable } from 'rxjs';
@Directive({
  selector: '[appTwoDigitDecimaNumber]'
})
//https://upliftskills.us/blog/2018/11/08/how-to-add-directive-dynamically-in-angular-2-4-6/
//https://stackoverflow.com/questions/41298168/how-to-dynamically-add-a-directive
export class TwoDigitDecimaNumberDirective {
  @Input() dontApply: boolean = true;
  @Input() inputApply: boolean = false;
  @Input() regex: RegExp = new RegExp(/^[-]?\d*\.?\d{0,2}$/g);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete', 'Control'];//, '-'
  constructor(private el: ElementRef) {
  }

  //https://stackoverflow.com/questions/47384952/directive-to-disable-cut-copy-and-paste-function-for-textbox-using-angular2
  //https://javascript.info/events-change-input
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    //https://stackoverflow.com/questions/50138910/angular-on-paste-event-get-content
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');

    ////https://stackoverflow.com/questions/23437476/in-typescript-how-to-check-if-a-string-is-numeric
    //if (isNaN(+pastedText))
    //  event.preventDefault();
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    //console.log(event);
    // Allow Backspace, tab, end, and home keys and ctrl + v and ctrl + a
    if (((event.key === "v" || event.key === "a") && event.ctrlKey) || (event.key === "Enter" && this.inputApply) || !this.dontApply || this.specialKeys.findIndex(x => x == event.key) !== -1) {
      return;//allowed to proceed
    }

    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
